import Layout from '@/layout'
import { getLS } from '@/utils/storage'

const getUsegasAnalysiszeTitle = () => {
	const userInfo = getLS('userInfo')
	const tenantType = userInfo?.tenantType
	return tenantType === '1' ? '用水分析' : '用气分析'
}

export default [
	{
		order: 3,
		path: '/customer-manage',
		component: Layout,
		meta: {
			title: '客户管理',
			subtitle: '客户',
			hiddenCrumb: true,
			icon: 'icon-lianxiren',
		},
		redirect: '/systemForTenant/open-account-setting',
		children: [
			{
				path: '',
				name: 'customerManage',
				meta: {
					title: '客户管理',
					keepAlive: true,
					permissions: ['monitor:ledger:user:list'],
				},
				component: () => import('@/pages/customer-manage/index.vue'),
			},
			{
				path: 'use-gas-analysis',
				name: 'useGasAnalysis',
				meta: {
					title: getUsegasAnalysiszeTitle(),
					keepAlive: false,
					permissions: ['monitor:ledger:user:list'],
					hidden: true,
					dynamicTitle: true,
					customCrumb: [
						{ customCrumbTitle: '客户管理', path: '/customer-manage' },
						{ customCrumbTitle: getUsegasAnalysiszeTitle() },
					],
				},
				component: () => import('@/pages/customer-manage/UseGasAnalysis.vue'),
			},
		],
	},
]
